import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, catchError, of } from 'rxjs';
import {
  PQRManutencaoFormacaoMaterialDto
} from '../../dtos'
import {
  MemoriaDeCalculoRequestDto,
} from '../../dtos/memoria-calculo-dto'

import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'


@Injectable({
  providedIn: 'root',
})
export class PQRManutencaoFormacaoMaterialService {
  private apiUrl = `${environment.apiUrl}/pqr`;
  private apiUrlRest = `${environment.apiUrl}/pqr-adicionais-manutencao-encargos`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRManutencaoFormacaoMaterial(): Observable<PQRManutencaoFormacaoMaterialDto[]> {
    return this.caqRequestService
      .get<MemoriaDeCalculoRequestDto>(this.apiUrl)
      .pipe(
        map((response) => {
          try {

            const dados = response.pqrManutencaoFormacaoMaterialList || [];
            // Mapeia para o formato do DTO
            dados.forEach((item: PQRManutencaoFormacaoMaterialDto, index: number) => {
              item.id = item.id || index + 1;
              item.codPqrAdicionaisManutencaoEncargos= item.codPqrAdicionaisManutencaoEncargos || item.id || index + 1;
              item.descricaoItem = item.descricaoItem || '';
              item.percentual = item.percentual || 0;
            });
            return dados;
          } catch (error) {
            console.warn('Erro ao processar dados PQR:', error);
            return [];
          }
        }),
        catchError((error) => {
          console.error('Erro na requisição:', error);
          return of([]);
        })
      );
  }

  salvarTodosPQRManutencaoEscolas(
    itens: PQRManutencaoFormacaoMaterialDto[],
    idsRemovidos: number[]
  ) {
    return firstValueFrom(
      this.caqRequestService.put<PQRManutencaoFormacaoMaterialDto[]>(
        `${this.apiUrlRest}/salvar-todos`,
        { itens, idsRemovidos }
      )
    );
  }
}
